import { bus } from '@/consts.js'

export default {
  name: 'Drawer',
  template: '#drawer-template',
  data () {
    return {
      open: false
    }
  },
  methods: {
    openDrawer () {
      if (this.open) {
        this.open = false
        bus.$emit('closeOverlay')
      } else {
        this.open = true
        bus.$emit('openOverlay')
      }
    }
  },
  mounted () {
    bus.$on('mobileDrawerOpen', () => {
      this.openDrawer()
    })

    bus.$emit('openOverlay')

    setTimeout(() => {
      this.open = true
      bus.$emit('openOverlay')
    }, 300)
  }
}



// WEBPACK FOOTER //
// ./src/components/Drawer.js